<template>
	<span>
		<about-hero></about-hero>
		<about-details></about-details>
		<page-footer></page-footer>
	</span>
</template>
<script>
	import AboutDetails from "@/components/AboutDetails";
	import AboutHero from "@/components/AboutHero";

	import PageFooter from "@/components/PageFooter";
	export default {
		name: "about",
		components: {
			AboutDetails,
			PageFooter,
			AboutHero,
		},
	};
</script>


